import type { IssuedQuoteVersion } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatCount, formatKrw } from '@/shared/lib';

interface OrderLinesTableProps {
  readonly lines: IssuedQuoteVersion['lines'];
}

const HEAD_CLASS = 'pb-3 pr-4 text-xs font-normal text-muted-foreground last:pr-0';
const CELL_CLASS = 'py-4 pr-4 align-top last:pr-0';

/** 주문한 발행본의 품목 줄 — 내 견적 표와 같은 결(굵은 머리선과 얇은 줄 선). 좁은 화면은 단가 칸을 숨긴다. */
export const OrderLinesTable = ({ lines }: OrderLinesTableProps): ReactElement => (
  <table aria-label="주문 품목" className="w-full text-sm">
    <thead className="text-left">
      <tr className="border-b border-foreground">
        <th scope="col" className={HEAD_CLASS}>
          품목
        </th>
        <th scope="col" className={`${HEAD_CLASS} text-right`}>
          수량
        </th>
        <th scope="col" className={`${HEAD_CLASS} hidden text-right sm:table-cell`}>
          단가
        </th>
        <th scope="col" className={`${HEAD_CLASS} text-right`}>
          금액
        </th>
      </tr>
    </thead>
    <tbody>
      {lines.map((line) => (
        <tr key={line.id} className="border-b border-foreground/10">
          <td className={`${CELL_CLASS} font-medium wrap-anywhere`}>{line.name}</td>
          <td className={`${CELL_CLASS} text-right whitespace-nowrap tabular-nums`}>
            {formatCount(line.quantity)}
          </td>
          <td
            className={`${CELL_CLASS} hidden text-right whitespace-nowrap text-muted-foreground tabular-nums sm:table-cell`}
          >
            {formatKrw(line.unitPrice)}
          </td>
          <td className={`${CELL_CLASS} text-right whitespace-nowrap font-semibold tabular-nums`}>
            {formatKrw(line.amount)}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
